import * as s from './MinimizedDock.css';

interface MinimizedDockProps {
  windows: Array<{ id: string; title: string }>;
  onRestore: (id: string) => void;
}

export function MinimizedDock({ windows, onRestore }: MinimizedDockProps) {
  if (windows.length === 0) return null;

  return (
    <div className={s.dock}>
      {windows.map((w) => (
        <button key={w.id} type="button" className={s.dockItem} onClick={() => onRestore(w.id)}>
          {w.title}
        </button>
      ))}
    </div>
  );
}
